/**
 * Employee PIN helpers — digits unique per enterprise for printer apps.
 * Mirrors backend validation in riverr-enterprise-nodejs/functions/users/staffPin.js
 */

export const STAFF_PIN_LEN = 4;
export const STAFF_PIN_MIN_LEN = 4;
export const STAFF_PIN_MAX_LEN = 8;

export function normalizeStaffPin(pin) {
  return String(pin ?? "").replace(/\D/g, "");
}

export function hasStaffPin(user) {
  const pin = normalizeStaffPin(user?.staffPin);
  return (
    pin.length >= STAFF_PIN_MIN_LEN && pin.length <= STAFF_PIN_MAX_LEN
  );
}

/**
 * True once the user has a confirmed PIN.
 * Auto-assigned provisional pins set `staffPinUserSet: false` and still require
 * signup confirmation. Legacy pins (flag missing) count as already set.
 */
export function hasStaffPinUserSet(user) {
  if (!hasStaffPin(user)) return false;
  if (user?.staffPinUserSet === false) return false;
  return true;
}

export function formatStaffPinDisplay(pin) {
  const normalized = normalizeStaffPin(pin);
  if (!normalized) return "—";
  return normalized;
}

export function maskedStaffPin(pin) {
  const normalized = normalizeStaffPin(pin);
  if (!normalized) return "••••";
  return "•".repeat(Math.min(normalized.length, STAFF_PIN_LEN));
}

/** Client-side format check. Returns an error message or "". */
export function staffPinError(pin, { confirmPin } = {}) {
  const normalized = normalizeStaffPin(pin);
  if (!normalized) return "Enter a Team Member Pin.";
  if (
    normalized.length < STAFF_PIN_MIN_LEN ||
    normalized.length > STAFF_PIN_MAX_LEN
  ) {
    return `Team Member Pin must be ${STAFF_PIN_MIN_LEN}–${STAFF_PIN_MAX_LEN} digits.`;
  }
  if (confirmPin != null && normalizeStaffPin(confirmPin) !== normalized) {
    return "Team Member Pins do not match.";
  }
  return "";
}
